import React from 'react';

import PropTypes from 'prop-types';

import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { red, pink } from '@mui/material/colors';

import { CodesDepotHorsMagasin, GroupeTraitementCodes } from 'constants.js';
import { Profils } from 'constants.js';

const NavBarUser = ({ utilisateur }) => {


    var afficheDepot = false;
    var afficheAgence = false;

    afficheDepot = utilisateur.groupes.find(x => x.code === GroupeTraitementCodes.Magasin) !== undefined && utilisateur.codePoste === Profils.Magasinier;
    afficheAgence = utilisateur.groupes.find(x => x.code === GroupeTraitementCodes.ForceVente) !== undefined && utilisateur.codePoste === Profils.Sedentaire;

    return (
        <>
            <Stack>
                <Typography variant="h6">
                    {utilisateur.prenom} {utilisateur.nom}
                </Typography>


                {afficheDepot && utilisateur.depot && CodesDepotHorsMagasin.indexOf(utilisateur.depot.code) === -1 &&(            
                    <Typography
                        variant="caption"
                        color="inherit"
                    >
                        Magasin : {utilisateur.depot.code} - {utilisateur.depot.nom}
                    </Typography>            
                )}

                {afficheDepot && !utilisateur.depot && utilisateur.depots && utilisateur.depots.length === 1 && (
                    <Typography
                        variant="caption"
                        color="inherit"
                    >
                        Magasin : {utilisateur.depots[0].code} - {utilisateur.depots[0].nom}
                    </Typography>
                )}

                {afficheDepot && utilisateur.depots && utilisateur.depots.length > 1 && (
                    <Typography
                        variant="caption"
                        color="inherit"
                    >
                        Magasins : {utilisateur.depots[0].code} - {utilisateur.depots[0].nom} (+{utilisateur.depots.length-1})
                    </Typography>
                )}


                {afficheAgence && utilisateur.codeAgence && (
                    <Typography
                        variant="caption"
                        color="inherit"
                    >
                        Agence : {utilisateur.codeAgence} - {utilisateur.libelleAgence}
                    </Typography>
                )}

            </Stack>

            <Avatar
                sx={{
                    ml: 1,
                    bgcolor: utilisateur.anonyme ? red[500] : utilisateur.administrateur ? pink[500] : ''
                }}

            >
                {`${utilisateur.codePO}`}
            </Avatar>
        </>
    );
}

NavBarUser.propTypes = {
    utilisateur: PropTypes.shape({
        nom: PropTypes.string,
        prenom: PropTypes.string,
        codeDepot: PropTypes.string,
        nomDepot: PropTypes.string,
        codeAgence: PropTypes.string,
        libelleAgence: PropTypes.string,
    })
};

export default NavBarUser;
